import React, { useState, useEffect } from "react";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import LoginHeader from "../login/LoginHeader";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "../sports-leagues/SportsLeagues.css";
import Challenge from "../sports-leagues/sports/Challenge";

export default function SportsLeagues(props) {
  const [loggedStatus, setLoggedStatus] = useState("");
  const navigate = useNavigate();
  const { sportId, leagueId } = useParams();
  var sport = "";

  useEffect(() => {
    var logged_status = localStorage.getItem("user_status");
    if (logged_status === "unlogged") {
      setLoggedStatus("unlogged");
    } else {
      setLoggedStatus("logged");
    }
  }, []);

  if (sportId == 1) {
    sport = "FOOTBALL COMPETITIONS";
  } else if (sportId == 3) {
    sport = "AMERICAN FOOTBALL COMPETITIONS";
  } else if (sportId == 16) {
    sport = "ICE HOCKEY COMPETITIONS";
  } else if (sportId == 2) {
    sport = "CRICKET COMPETITIONS";
  } else if (sportId == 18) {
    sport = "RUGBY LEAGUE";
  } else if (sportId == 11) {
    sport = "ESPORT COMPETITIONS";
  }

  return (
    <React.Fragment>
      {loggedStatus === "logged" ? <Header /> : <LoginHeader />}
      <div className="sports_league">
        <div className="my_sports_league_center">
          <label className="lbl_sports_league">{sport}</label>
        </div>
      </div>
      <div className="sports_league_container primary-background">
        <div className="page_content_center">
          <h5 className="sports_league_select_competition text-white">
            Select your competition, entry fee and the number of players you
            wish to compete against, then press play
          </h5>
          <Challenge />
        </div>
      </div>
      <Footer />
    </React.Fragment>
  );
}